import { Box, BoxProps, Flex, Stack, Text } from "@chakra-ui/react";
import TextWithTooltip from "components/TextWithTooltip";
import { memo } from "react";
import { NoFieldPreviewProps } from "../fields/types";
import NoFieldPreview from "./NoFieldPreview";

interface Props extends NoFieldPreviewProps {
  title?: any;
  children?: React.ReactNode;
}

const FieldPreviewWrapper = (props: Props & Omit<BoxProps, "title">) => {
  const {
    title,
    children,
    index,
    allItemResultCount,
    prevItemResultCount,
    ...rest
  } = props;

  return (
    <Stack gap="0.5rem" {...rest}>
      <Flex
        alignItems={"center"}
        gap={"0.5rem"}
        fontWeight="bold"
        fontSize={"1.6rem"}
        className="field-title"
        position={"relative"}
      >
        <NoFieldPreview
          index={index}
          prevItemResultCount={prevItemResultCount}
          allItemResultCount={allItemResultCount}
        />

        <TextWithTooltip
          text={title}
          textProps={{
            as: "span",
            noOfLines: 1,
          }}
        />
      </Flex>
      <Box className="field-wrapper" pl="1.2rem">
        {children}
      </Box>
    </Stack>
  );
};

export default memo(FieldPreviewWrapper);
